export class SysUser{
    id:number;
    email:string;
    password:string;
}